import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { WarehouseList } from './pages/WarehouseList';
import { WarehouseDetail } from './pages/WarehouseDetail';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-gray-50" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<WarehouseList data-id="element-4" />} data-id="element-3" />
          <Route path="/warehouse/:id" element={<WarehouseDetail data-id="element-6" />} data-id="element-5" />
        </Routes>
      </div>
    </BrowserRouter>;
}